<template>
  <div @mousemove="onMouseMove">
    <slot :x="x" :y="y">
      default content, mouse position {{ x }}, {{ y }}
    </slot>
  </div>
</template>

<script>
// usage:
// <VueMouseTrack v-slot="{x,y}">
//   <h1>The Mouse position is ({{ x }}, {{ y }})</h1>
// </VueMouseTrack>
export default {
  data() {
    return {
      x: 0,
      y: 0,
    }
  },
  methods: {
    onMouseMove(e) {
      const currentTargetRect = e.currentTarget.getBoundingClientRect()

      const x =
        Math.max(
          0,
          Math.round(
            ((e.clientX - currentTargetRect.left) / currentTargetRect.width) *
              10000,
          ) / 100,
        ) + '%'

      const y =
        Math.max(
          0,
          Math.round(
            ((e.clientY - currentTargetRect.top) / currentTargetRect.height) *
              10000,
          ) / 100,
        ) + '%'

      this.x = x
      this.y = y
    },
  },
}
</script>
